import { render, staticRenderFns } from "./CashAdvanceDetail.vue?vue&type=template&id=54e228cd"
import script from "./CashAdvanceDetail.vue?vue&type=script&lang=js"
export * from "./CashAdvanceDetail.vue?vue&type=script&lang=js"
import style0 from "./CashAdvanceDetail.vue?vue&type=style&index=0&id=54e228cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports